import React from 'react';
import {DialogRegistration} from '../model/DialogRegistration';
import {InfoPopup} from './InfoPopup';

const defaultProps: Required<Texts> = {
    title: 'Something went wrong',
    details:
        "We’re sorry that you have to experience some problems. Don't worry, we'll fix it. Please try again later.",
};

interface Texts {
    title?: string;
    details?: string;
}

interface Callbacks {
    onExitEnd?: () => void;
}

export interface DialogRegistrationProps extends Texts, Callbacks {}

export const GenericErrorMsg = DialogRegistration.create<DialogRegistrationProps>({
    name: 'GenericErrorAlert',
    Component: ({
        title = defaultProps.title,
        details = defaultProps.details,
        onExitEnd,
    }: DialogRegistrationProps = defaultProps) => (
        <InfoPopup type='error' title={title} details={details} onExitEnd={onExitEnd} />
    ),
});
